import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-test-equipment-references',
  templateUrl: './test-equipment-references.component.html',
  styleUrls: ['./test-equipment-references.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestEquipmentReferencesComponent {
  @Input() public referenceConfig: any[];
}
